import request from "../request";

/**
 * Get audit trails for a specific entity
 * @param {string} entityName - Name of the entity
 * @param {string} entityId - ID of the entity
 * @param {Object} filters - Query parameters for filtering
 * @returns {Promise} - Promise resolving to audit trail data
 */
const getEntityAuditTrails = (entityName, entityId, filters = {}) => {
	const queryParams = new URLSearchParams();

	// Add filters to query params
	if (filters.startDate) queryParams.append("startDate", filters.startDate);
	if (filters.endDate) queryParams.append("endDate", filters.endDate);
	if (filters.action) queryParams.append("action", filters.action);
	if (filters.userId) queryParams.append("userId", filters.userId);
	if (filters.ipAddress) queryParams.append("ipAddress", filters.ipAddress);
	if (filters.page) queryParams.append("page", filters.page);
	if (filters.limit) queryParams.append("limit", filters.limit);

	const queryString = queryParams.toString()
		? `?${queryParams.toString()}`
		: "";
	return request.get(
		`entities/${entityName}/${entityId}/audit-trails${queryString}`,
	);
};

/**
 * Get recent activity by a specific user
 * @param {string} userId - ID of the user
 * @param {Object} filters - Query parameters for filtering
 * @returns {Promise} - Promise resolving to user activity data
 */
const getUserActivity = (userId, filters = {}) => {
	const queryParams = new URLSearchParams();

	// Add filters to query params
	if (filters.startDate) queryParams.append("startDate", filters.startDate);
	if (filters.endDate) queryParams.append("endDate", filters.endDate);
	if (filters.entityName)
		queryParams.append("entityName", filters.entityName);
	if (filters.action) queryParams.append("action", filters.action);
	if (filters.page) queryParams.append("page", filters.page);
	if (filters.limit) queryParams.append("limit", filters.limit);

	const queryString = queryParams.toString()
		? `?${queryParams.toString()}`
		: "";
	return request.get(`audit-trails/user-activity/${userId}${queryString}`);
};

const auditTrailService = {
	getEntityAuditTrails,
	getUserActivity,
};

export default auditTrailService;
